<template>
  <el-row :gutter="10">
    <el-col :span="10">
      <page-category-table />
    </el-col>
    <el-col :span="14">
      <page-category-options-table />
    </el-col>
  </el-row>
</template>
<script>
import PageCategoryTable from './components/dict-table/index.vue'
import PageCategoryOptionsTable from './components/dict-options-table/index.vue'
export default {
  name: 'master-accessories',
  components: {
    PageCategoryTable,
    PageCategoryOptionsTable,
  },
}
</script>
